// Single source of truth for the tools on the site. The navbar "apps" menu,
// the /apps index page, and the landing-page dropdown all read from this list,
// so adding a tool means adding one entry here (plus its route in App.js and
// a PAGE_META / sitemap entry).
//
// thumb: image in public/AppThumbs (shown on the /apps index).
const appsList = [
  {
    id: 'heattracker',
    name: 'HEATTRACKER',
    route: '/heattracker',
    description: 'Real-time stereo field and frequency heat map. Drop in a file, share a tab, or use an audio input.',
    thumb: '/AppThumbs/heattracker.jpg',
  },
  {
    id: 'taptempo',
    name: 'Tap Tempo',
    route: '/taptempo',
    description: 'Tap along to find a tempo in BPM.',
    thumb: '/AppThumbs/taptempo.jpg',
  },
];

export default appsList;
